import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";

import getTBWStore from "../../../stores/developer-store/tbw-store";
import { TCorePage, TTBWExtraData } from "../../../Types";
import Et3Button from "../../et3-button";

const TempBanButton = withLiteObserverAndTheme<{
  extraData: TTBWExtraData;
  fromPage: TCorePage;
  disabled: boolean;
  size: "DEFAULT" | "MEDIUM";
}>((props) => {
  const { extraData, fromPage, disabled, size } = props;
  return (
    <Et3Button
      onClick={async () => {
        await getTBWStore().showActionTBWPopUp({
          type: "ACTION_TBW",
          headerMessage: i18n.getWithExtraData(
            "SELECT_REASONS_OF_ACTION",
            "temporary_banned"
          ),
          actionName: "temporary_banned",
          fromPage,
          extraData,
          issueAudit: "",
          eventId: -1
        });
      }}
      size={size}
      isEnabled={!disabled}
      type="REJECT"
      text="TEMPORARY_BAN"
    />
  );
});
export default TempBanButton;
